import React, { FunctionComponent } from 'react'
import classNames from 'classnames'
import { t } from '@lingui/macro'

import IconTick from '../../../../components/common/icon/IconTick'

import { UsersImportStep } from '../../types/UserImportStep'

import './StepIndicator.less'

interface IStepItemProps {
  step: UsersImportStep
  currentStep: UsersImportStep
  loading: boolean
}

const StepItem: FunctionComponent<IStepItemProps> = ({
  currentStep,
  step,
  loading
}) => {
  // Should be in render function otherwise
  // will cache previous translation after language change
  const STEP_CAPTIONS = {
    [UsersImportStep.DATA]: t`Data`,
    [UsersImportStep.FIELDS]: t`Fields`,
    [UsersImportStep.SETTINGS]: t`Settings`
  }
  const current = step === currentStep

  const itemClass = classNames('StepIndicator__item', {
    current,
    passed: step < currentStep,
    upcoming: step > currentStep,
    loading: current && loading
  })

  return (
    <li className={itemClass}>
      <div className="StepIndicator__marker">
        {step < currentStep ? <IconTick /> : ''}
      </div>
      <div className="StepIndicator__caption">{STEP_CAPTIONS[step]}</div>
    </li>
  )
}

interface IStepIndicatorProps {
  currentStep: UsersImportStep
  loading: boolean
}

export const StepIndicator: FunctionComponent<IStepIndicatorProps> = ({
  currentStep,
  loading
}) => {
  const itemProps = { currentStep, loading }

  return (
    <div className="StepIndicator">
      <ul className="StepIndicator__list">
        <StepItem step={UsersImportStep.DATA} {...itemProps} />
        <StepItem step={UsersImportStep.FIELDS} {...itemProps} />
        <StepItem step={UsersImportStep.SETTINGS} {...itemProps} />
      </ul>
    </div>
  )
}
